import React, { useState , useEffect} from "react";
import { BiCheck, BiPlus, BiMinus } from "react-icons/bi";
import { getTotalMinted, getuserPurchase , getUSDTbalance, getAllocation, approveUSDT, mintNFT} from "../contracts/functions";
import { connectWallet } from "../contracts/account";
import {useParams} from "react-router-dom"
import { web3 } from "../contracts/account";

import LoadingSpinner from "./Loader/Loader";
import ProgressBar from "./Progressbar/Progressbar";
import styles from "./GetYourNft.module.css";
import MyCountDown from "./CountDown/CountDown";

const GetYourNft = () => {
  const [mint, setMint] = useState(1);
  const [currency, setCurrency] = useState(0);
  const [minting, setMinting] = useState(false);
  const [totalRaised, settotalRaised] = useState(0);
  const [userPurchased, setuserPurchased] = useState(2);
  const [getbalUSDT, setgetbalUSDT] = useState(0);
  const [getAlloc, setAlloc] = useState(0);
  const [account, setAccount] = useState("none");
  const [bigButtonLabel, setbigButtonLabel]= useState("Connect Wallet");
  const [refAddress, setRefAddr] = useState("0x2D4C407BBe49438ED859fe965b140dcF1aaB71a9");

  const {ref} = useParams();


  const setValues = async ()  => {
    settotalRaised(await getTotalMinted());
    setuserPurchased(await getuserPurchase(account));
    setgetbalUSDT(await getUSDTbalance(account));
    setAlloc(await getAllocation(account));
   // 
    setRefAddr (ref);
    setAccount(await connectWallet());
  }

  const setWallets = async () => {
    const account = await web3.eth.requestAccounts();
    const userAccount = account[0];
    setAccount(userAccount); 
    return userAccount;
  }
 console.log(refAddress);

  const bigButtonHandler = async () => {
    if (!account) {
      setbigButtonLabel("Connect Wallet");
    } else if (getAlloc == 0 ) {
      setbigButtonLabel("Enable USDT");
    }  else if (getAlloc > 0) {
      setbigButtonLabel("BUY");
    }
    console.log ("buy Token")
  }


  useEffect(() => {
    setValues();
  });

  useEffect(() => {
    const interval = setInterval(() => {
      bigButtonHandler();
      console.log('This will run every second!');
    }, 1000);
    return () => clearInterval(interval);
  }, []);


  const increase = () => {
    if ((mint + userPurchased) == 5) {
      return alert("you cant buy more than your allocation")
    }
    if (mint < 5) {
      setMint((prev) => prev + 1);
    }
    
  };
  const decrease = () => {
    if (mint == 1) {
      return alert("Minimum buy is 10$")
    }
    if (mint > 0) {
      setMint((prev) => prev - 1);
    }
  };
  const currencies = ["USDT"];
  return (
    <section className={styles.getYourNft}>
      <div className={styles.headingAndLive}>
        <h3 className={styles.heading}>Get your NFT</h3>
        <div className={styles.timerContainer}>
          <div className={styles.timer}>
            <span className={styles.circle} />
            <span className={styles.live}>Live</span>
            <span className={`${styles.live} ${styles.time}`}>
              {" "}
              <MyCountDown dayCount="Nov 03 2022 05:30:01" />{" "}
            </span>
          </div>
        </div>
      </div>
      <div className={styles.mintingWrapper}>
        <p className={styles.mintingDate}>
          <span className={styles.key}> Minting date : </span>
          <spna className={styles.value}>
            OCT 3 2:00am - NOV 3 2:00am CET
          </spna>
        </p>{" "}
        <p className={styles.mintingDate}>
          <span className={styles.key}> Price : </span>
          <spna className={styles.value}>
            10$ per NFT <span className={styles.key}></span>
          </spna>
        </p>
      </div>
      <h5 className={styles.title}>
        How many NFTs to mint?{" "}
        <span className={styles.maxMint}>USDT Bal: {getbalUSDT}</span>
      </h5>
      <div className={styles.mintContainer}>
        <BiMinus
        style={{userSelect: 'none'}}
          onClick={decrease}
          className={`${styles.mint} ${mint === 0 && styles.mintDeactive}`}
        />
        <span className={styles.mint}>{mint}</span>{" "}
        <BiPlus
        style={{userSelect: 'none'}}
          onClick={increase}
          className={`${styles.mint} ${mint === 5 && styles.mintDeactive}`}
        />
      </div>
      <h5 className={styles.title}>Select currency to spend</h5>
      <div className={styles.currencyContainer}>
        {currencies.map((item, i) => (
          <div
            className={`${styles.currency} ${
              currency === i && styles.currencyActive
            }`}
            key={i}
            onClick={() => setCurrency(i)}
          >
            {currency === i && <BiCheck className={styles.ok} />} {item}
          </div>
        ))}
      </div>
      <button
        className={styles.loader}
        onClick={() => {
          if(account == "none"){
            if(!window.ethereum){
              return alert('Please use Trust wallet or Metamask browser')
            }
            setWallets();
          } else if(getAlloc == 0) {
            approveUSDT();
          } else{
            mintNFT(web3.utils.toWei(mint , "ether") , refAddress, account);
          }
          setTimeout(() => {
            setMinting(false);
          }, 3000);
        }}
      >
        {minting ? (
          <LoadingSpinner />
        ) : (
          <span className={styles.minting}>{bigButtonLabel}</span>
        )}
      </button>
      <div className={styles.transaction}>
        <p className={styles.transactionKey}>Transaction Fee</p>
        <p className={`${styles.transactionValue} ${styles.transactionKey}`}>
          ~0.07$ BNB
        </p>
      </div>
      <div className={`${styles.transaction} ${styles.transactionBottom}`}>
        <p className={styles.transactionKey}>Total Fee</p>
        <p className={`${styles.transactionValue} ${styles.transactionKey}`}>
          { mint * 10} USDT
        </p>
      </div>{" "}
      <div className={styles.progressAndMinted}>
        <ProgressBar bgcolor="#404042" progress={userPurchased} max={5} height={10} />
        <div className={styles.mintedContainer}>
          <p className={styles.minted}>My Mint Allocation</p>
          <p className={styles.minted}>{userPurchased} / 5</p>
        </div>
      </div>{" "}
      <div className={styles.progressAndMinted}>
        <ProgressBar bgcolor="#404042" progress={totalRaised} max={10000} height={10} />
        <div className={styles.mintedContainer}>
          <p className={styles.minted}>Globally minted</p>
          <p className={styles.minted}>{totalRaised} / 10000</p>
        </div>
      </div>
    </section>
  );
};

export default GetYourNft;
